  <div *ngIf="tgrSummary; else EmptyTemplate">
  <h2 class="titulo" style="margin-top: -30px;">Información TGR ({{this.tgrSummary.date | date: 'dd/MM/yyyy'}})
    <span 
     
      (click)="updateTGR()" class="span_header" matTooltip="Actualizar">
      <i-tabler class="icon-20" name="refresh">
      </i-tabler>  
    </span>
  </h2>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3>Vigente</h3>
      </div>
      <div class="col">
        <h3>Morosa (S/C)</h3>
      </div>
      <div class="col">
        <h3>Con Convenio</h3>
      </div>
      <div class="col">
        <h3></h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        {{this.tgrSummary.amountVigente | currency: 'CLP'}}
      </div>
      <div class="col">
        {{this.tgrSummary.amountMorosa | currency: 'CLP'}}
      </div>
      <div class="col">
        {{this.tgrSummary.amountConvenio | currency: 'CLP'}}
      </div>
      <div *ngIf="tgrSummary.amountConvenio>0" class="col">
        <button mat-raised-button color="primary" style="margin-top: -40px;" (click)="abrirDetalleTgr()" >Ver Detalle</button>
      </div>
    </div>

  </div>
  <br>
  <div class="container">
    <iframe [src]="this.tgrDebtUrl" width="100%" style="height: 60vh;"></iframe>
  </div>
</div>
<ng-template #EmptyTemplate>
  <h2 class="titulo" style="margin-top: -30px;">Información TGR (S/Inf.)
    <span 
      (click)="updateTGR()" class="span_header" matTooltip="Actualizar">
      <i-tabler class="icon-20" name="refresh">
      </i-tabler>  
    </span>
  </h2>
</ng-template>
